@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.network.serializers.UuidSerializer
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class UpdateTrainingProgramRequest(
    @Serializable(with = UuidSerializer::class) val trainingProgramGuid: Uuid,
    val goals: Set<MainGoal>,
    val level: LevelKey,
    val ageGroup: AgeGroupKey,
    val schedule: List<DayAndDuration>
)
